import { css } from 'twin.macro';
import { Badge } from 'react-bootstrap';
import { FaWheelchair, FaRestroom, FaCar, FaBuilding } from 'react-icons/fa';

function SelectedPlaceAccessibility({ accessibility }) {
    if (!accessibility) return null;

    const hasDetails = Boolean(
        accessibility.entranceInfo ||
            accessibility.elevatorInfo ||
            accessibility.accessibleRestrooms ||
            accessibility.buildingInfo ||
            accessibility.lactationRoom ||
            accessibility.parkingInfo ||
            accessibility.additionalNotes
    );

    return (
        <>
            <div
                css={css`
                    margin-top: 8px;
                    display: flex;
                    gap: 4px;
                    flex-wrap: wrap;
                    justify-content: center;
                `}
            >
                {accessibility.wheelchairAccessible && (
                    <Badge variant="success">
                        <FaWheelchair style={{ marginRight: 4 }} /> Accessible
                    </Badge>
                )}
                {accessibility.accessibleRestroom && (
                    <Badge variant="info">
                        <FaRestroom style={{ marginRight: 4 }} /> Restroom
                    </Badge>
                )}
                {accessibility.accessibleParking && (
                    <Badge variant="primary">
                        <FaCar style={{ marginRight: 4 }} /> Parking
                    </Badge>
                )}
                {accessibility.elevatorAvailable && (
                    <Badge variant="secondary">
                        <FaBuilding style={{ marginRight: 4 }} /> Elevator
                    </Badge>
                )}
            </div>

            {hasDetails && (
                <div
                    css={css`
                        margin-top: 8px;
                        width: 100%;
                        text-align: left;
                        font-size: 0.85rem;
                        color: #555;
                    `}
                >
                    <details>
                        <summary style={{ cursor: 'pointer', fontWeight: 600, color: '#333' }}>
                            Accessibility Details
                        </summary>
                        <div
                            css={css`
                                margin-top: 6px;
                            `}
                        >
                            {accessibility.entranceInfo && (
                                <p className="mb-1">
                                    <b>Entrance:</b> {accessibility.entranceInfo}
                                </p>
                            )}
                            {accessibility.elevatorInfo && (
                                <p className="mb-1">
                                    <b>Elevator:</b> {accessibility.elevatorInfo}
                                </p>
                            )}
                            {accessibility.accessibleRestrooms && (
                                <p className="mb-1">
                                    <b>Restrooms:</b> {accessibility.accessibleRestrooms}
                                </p>
                            )}
                            {accessibility.buildingInfo && (
                                <p className="mb-1">
                                    <b>Building:</b> {accessibility.buildingInfo}
                                </p>
                            )}
                            {accessibility.lactationRoom && (
                                <p className="mb-1">
                                    <b>Lactation Room:</b> {accessibility.lactationRoom}
                                </p>
                            )}
                            {accessibility.parkingInfo && (
                                <p className="mb-1">
                                    <b>Parking:</b> {accessibility.parkingInfo}
                                </p>
                            )}
                            {accessibility.additionalNotes && (
                                <p className="mb-1">
                                    <b>Notes:</b> {accessibility.additionalNotes}
                                </p>
                            )}
                        </div>
                    </details>
                </div>
            )}
        </>
    );
}

export default SelectedPlaceAccessibility;
